import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiLogOut, FiMenu, FiX, FiCheckSquare, FiGrid } from 'react-icons/fi';

const JudgeNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const navItems = [
    { path: '/judge/projects', label: 'تحكيم المشاريع', icon: FiCheckSquare },
    { path: '/judge/teams', label: 'عرض الفرق', icon: FiGrid },
  ];

  return (
    <>
      {/* Top Header - Mobile */}
      <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-dark-blue border-b border-yellow z-40 flex items-center justify-between px-4">
        <div className="flex items-center gap-2">
          <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" className="w-8 h-8" />
          <span className="text-white font-bold">لوحة التحكيم</span>
        </div>
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="text-white p-2"
        >
          {isMobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {/* Sidebar - Desktop */}
      <div className={`hidden md:flex flex-col fixed top-0 right-0 bottom-0 bg-dark-blue border-l border-yellow transition-all duration-300 z-30 ${isSidebarOpen ? 'w-64' : 'w-20'}`}>
        <div className="h-20 flex items-center justify-center border-b border-white/10 relative">
          {isSidebarOpen ? (
            <div className="flex items-center gap-2">
              <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" className="w-10 h-10" />
              <span className="text-white font-bold text-lg">لوحة التحكيم</span>
            </div>
          ) : (
            <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Logo" className="w-10 h-10" />
          )}
          
          <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="absolute -left-3 top-1/2 transform -translate-y-1/2 bg-yellow text-dark-blue p-1 rounded-full border-2 border-dark-blue hover:scale-110 transition-transform"
          >
            {isSidebarOpen ? <FiX size={12} /> : <FiMenu size={12} />}
          </button>
        </div>

        <div className="flex-1 py-6 px-3 space-y-2 overflow-y-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 ${
                  isActive 
                    ? 'bg-yellow text-dark-blue font-bold shadow-lg shadow-yellow/20' 
                    : 'text-white/70 hover:bg-white/5 hover:text-white'
                } ${!isSidebarOpen && 'justify-center'}`}
              >
                <Icon size={20} />
                {isSidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </div>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={handleLogout}
            className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-400 hover:bg-red-500/10 transition-all duration-300 ${!isSidebarOpen && 'justify-center'}`}
          >
            <FiLogOut size={20} />
            {isSidebarOpen && <span>تسجيل الخروج</span>}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-30 bg-black/50 backdrop-blur-sm" onClick={() => setIsMobileMenuOpen(false)} />
      )}

      {/* Mobile Sidebar */}
      <div className={`md:hidden fixed top-16 right-0 bottom-0 w-64 bg-dark-blue border-l border-yellow transform transition-transform duration-300 z-40 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex-1 py-6 px-3 space-y-2 overflow-y-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-300 ${
                  isActive 
                    ? 'bg-yellow text-dark-blue font-bold' 
                    : 'text-white/70 hover:bg-white/5 hover:text-white'
                }`}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </Link>
            );
          })}
          
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-400 hover:bg-red-500/10 transition-all duration-300 mt-4"
          >
            <FiLogOut size={20} />
            <span>تسجيل الخروج</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default JudgeNav;

